import React from 'react';
import { BrandDealsOverview } from './BrandDealsOverview';

export const DealsPartnerships = () => {
  return <BrandDealsOverview />;
};